<template>
  <div class="cart-index">
    <Loading v-if="!requested" />
    <NavUser @evtLogout="evtLogout" />
    <!-- 顶部导航信息 -->
    <TopNavbar :title="'Order Summary'" :bgColor="'bg-red'" />
    <div v-if="requested" class="main">
      <div class="order-store-name flex flex-center">
        <div class="store-logo"><img :src="storeinfo.logo" /></div>
        <div class="store-name">{{ storeinfo.title }}</div>
      </div>
      <!-- 桌子信息 -->
      <TablesInfo :tablesInfo="tablesInfo" />
      <div class="product-list">
        <div class="list-header bg-red flex flex-start justify-between">
          <div class="item-name"></div>
          <div class="item-qty">Qty.</div>
          <div class="item-price">Price</div>
        </div>
        <!-- 已选择的商品列表 -->
        <div class="list-items flex flex-start justify-between flex1" v-for="(item, index) in goodsList" :key="index" :class="{'line-top':index}">
          <div class="item-image">
            <img :src="item.detail.thumb" />
          </div>
          <div class="item-name">
            <div class="w600">{{item.name || item.detail.title}}</div>
            <div>
              <span v-for="(optName, optIndex) in item.options" :key="optIndex">
                <!-- <Tags :text="optName" v-if="optIndex != 'optionid'" /> -->
                <Tags v-for="(vname, vkey) in optName" :key="vkey" :text="vname" />
              </span>
            </div>
          </div>
          <div class="item-qty">{{item.qty}}</div>
          <div v-if="parseInt(item.isspecial) == 2" class="item-price">RMxx {{ item.optionname }}</div>
          <div v-if="parseInt(item.isspecial) != 2" class="item-price">RM {{ fmPrice(parseFloat(item.price)*parseInt(item.qty)) }}</div>
        </div>
      </div>
      <div class="custom-form">
        <!--
        <div class="padd5px">
          <div class="flex justify-between padd5px user-nav-name">
            <div class="user-nav-name-label">Membership ID</div>
            <input ref="membership_id" class="user-nav-name-value inputfocus" v-model="membership_id" placeholder="Your membership ID" />
          </div>
        </div>
        -->

        <!-- 优惠券单元格 -->
        <van-cell :title="'Coupons'" is-link :value="coupon_code || '0 coupons available'" @click="popupCoupon = coupon_list.length" />
        <van-popup v-model="popupCoupon" position="bottom" :style="{ height: '20%' }">
          <div class="flex justify-between padd5px">
            <van-button type="danger" size="mini" @click="cleanCoupon">Clean</van-button>
            <van-button type="info" size="mini" @click="applyCoupon">Okey</van-button>
          </div>
          <van-radio-group v-model="coupon_code">
            <van-cell-group>
              <van-cell v-for="itemCoupon in coupon_list" :key="itemCoupon" :title="itemCoupon.title" clickable @click="coupon_code = itemCoupon.name">
                <van-radio slot="right-icon" :name="itemCoupon.name" />
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </van-popup>
        <van-cell-group v-if="visiable_realname">
          <div class="padd5px">
            <div class="flex justify-between padd5px user-nav-name">
              <div class="user-nav-name-label">Name *</div>
              <input ref="receiver_name" class="user-nav-name-value inputfocus" v-model="receiver_name" placeholder="Your name" />
            </div>
          </div>
        </van-cell-group>
        <van-cell-group v-if="visiable_phone">
          <div class="padd5px">
            <div class="flex justify-between padd5px user-nav-name">
              <div class="user-nav-name-label">Mobile No. *</div>
              <vue-tel-input 
                ref="receiver_phone" 
                :onlyCountries="phoneCountries" 
                :required="true" 
                class="contact-phone " 
                v-model="receiver_phone" 
                defaultCountry='MY'
                mode='international'
                @validate="validateMobileInput" />
            </div>
          </div>
        </van-cell-group>
        <van-cell-group v-if="visiable_email">
          <div class="padd5px">
            <div class="flex justify-between padd5px user-nav-name">
              <div class="user-nav-name-label">Email *</div>
              <input ref="email" class="user-nav-name-value inputfocus" v-model="email" placeholder="abc@example.com" />
            </div>
          </div>
        </van-cell-group>
        <van-cell-group v-if="isLogin">
          <div class="padd5px">
            <div class="padd5px">
              <van-checkbox class="checkbox-mobile-label" icon-size="12px" v-model="checkbox_mobile_value" shape="square">{{checkbox_mobile_label}}</van-checkbox>
            </div>
          </div>
        </van-cell-group>
        <van-cell-group>
          <van-field v-if="!isEpointEnabled" v-model="order_remark" rows="5" autosize type="textarea" placeholder="Order's Remark"/>
          <van-field v-if="isEpointEnabled" v-model="order_remark" rows="5" autosize type="textarea" placeholder="Order's Remark (max 19 characters)" maxlength="19"/>
        </van-cell-group>
        <div style="padding:8px 8px 18px 8px;">
          <van-checkbox class="checkbox-mobile-label" icon-size="12px" v-model="checkbox_tc_value" shape="square">
            By placing this order, I agree to the FastOrder.my
            <span class="linkcolor" @click="funTC('https://business.fastorder.my/terms-conditions/')">Terms & Condition</span> and
            <span class="linkcolor" @click="funTC('https://business.fastorder.my/privacy-policy/' )">Privacy Policy</span>
          </van-checkbox>
        </div>
      </div>
    </div>
    <div v-if="requested" class="footer bg-red">
      <div class="summary">
        <div class="row" v-for="(item, index) in cart.summmary" :key="index">
          <div class="flex justify-end">
            <div class="label">{{item.label}}
              <span v-if="item.type=='promo' && isCoupon">({{coupon_code}})</span>
            </div>
            <div class="colons">:</div>
            <div class="currency">RM</div>
            <div class="text">{{ item.text }}</div>
          </div>
        </div>
      </div>
      <div class="flex flex-center justify-between place-order">
        <div class="rm-price">RM {{ cartTotal }}</div>
        <div v-if="!requestHisOrder" class="btn-order">
          <div class="flex flex-center">
            <div>Confirm</div>
            <van-loading color="#ffffff" size="18" />
          </div>
        </div>
        <div v-if="requestHisOrder" class="btn-order" @click="checkFormField">Confirm</div>
      </div>
    </div>
  </div>
</template>
<script>
import TopNavbar from '../../components/common/TopNavbar.vue'
import NavUser from '../../components/common/NavUser.vue'
import TablesInfo from '../../components/common/TablesInfo.vue'
import Loading from '../../components/common/Loading.vue'
import Tags from '../../components/common/Tags.vue'
import { Toast } from 'vant';
import { isNumber } from 'util'
import { cartPage, addToOrder, checkHistoryExist, validateBusinessAndHoliday } from '@/api/api'
import mockDemo from '@/api/mock'
import { cartMixin } from '@/mixins/cartMixin'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    TopNavbar, TablesInfo, Tags, Loading, NavUser
  },
  props: {
  },
  data() {
    return {
      requested: false,
      receiver_name: '',
      receiver_phone: '',
      email: '',
      phoneCountries: ['MY', 'SG', 'ID'],
      checkbox_tc_value: true,
      checkbox_mobile_value: 0,
      checkbox_mobile_label: 'Update this mobile number into my profile.',
      import_text1: '* Important: ',
      import_text2: 'You will receive an order confirmation SMS and please verify with merchant with your mobile number while collecting your food.',
      tablesInfo: {},
      goodsList: [],
      storeinfo: {},
      cartTotal: 0.00,
      cart: {
        summmary: []
      },
      store: {},
      validateTime: false,
      isCoupon: false,
      popupCoupon: false,
      coupon_code: '',
      coupon_list: [],
      order_remark: '',
      membership_id: '',
      receiver_addr1: '',
      receiver_addr2: '',
      receiver_addr3: '',
      reqUrl: false,
      show: false,
      isWeixin: false,
      is_required_address_takeaway: false,
      isLogin: false,
      requestHisOrder: true, //检查历史订单的 request 状态
      hasHistoryOrder: false, //是否存在历史订单
      loading_confirm: false, //是否在确认提交中
      ssouser: false, //sso.user 信息
      dish_datetime: '',
      showDishDatetime: false,
      visiable_realname: false,
      visiable_phone: false,
      visiable_email: false,
      dishDatetime: new Date(),
      sso: {},
      isEpointEnabled: false,
      isMobileValid: false
    }
  },
  created() {
    // this.checkIsBackPage()
    this.get_data()
    this.is_weixin = this.isOnWeixin()
  },
  mixins: [cartMixin],
  computed: {},
  methods: {
    checkIsBackPage() {
      window.addEventListener('pageshow', function (event) {
        if (event.persisted || window.performance && window.performance.navigation.type == 2) {
          //location.reload()
          this.$toast('当前为后退页面返回来的事件')
        }
      })
    },
    get_data() {
      this.getApiData()
    },
    getApiData() {
      const todo = cartindex => {
        const tempcart = cartindex && cartindex.cart.map(item => {
          let itemFinalPrice = item.marketprice
          if (item.isspecial) {
            if (parseInt(item.isspecial) == 2) {
              itemFinalPrice = item.price
            }
          }
          const tempItem = {
            detail: {
              thumb: item.thumb,
              title: item.title,
            },
            name: item.title,
            options: [item.optionname],
            qty: item.total,
            price: itemFinalPrice
          }
          return tempItem
        })

        this.isEpointEnabled = cartindex.store.pos_status && cartindex.store.pos_name==='epoint'? true:false;
        this.goodsList = tempcart
        this.tablesInfo = {
          title: cartindex.table.title,
          promo: cartindex.store.promo || '',
          tel: cartindex.store.tel,
          table: cartindex.table,
          tablezones: cartindex.tablezones,
        }
        this.storeinfo = {
          title: cartindex.store.title,
          logo: cartindex.store.logo,
          is_rest: cartindex.store.is_rest,
          is_show: cartindex.store.is_show
        }
        this.visiable_realname = (cartindex.store.visiable_realname && cartindex.store.visiable_realname_dinein) || false
        this.visiable_phone = (cartindex.store.visiable_phone && cartindex.store.visiable_phone_dinein) || false
        this.visiable_email = (cartindex.store.visiable_email && cartindex.store.visiable_email_dinein) || false
        this.cart.summmary = cartindex.summmary
        this.cartTotal = cartindex.cartTotal || '0.00'
      }
      if (this.isDevEnv()) {
        const cartindex = mockDemo.cartPage.data
        cartindex && todo && todo(cartindex)
        setTimeout(() => {
          this.requested = true
        }, 1000)
      } else {
        const actname = 'wapmenu'
        const queryParams = this.getUrlParams({ 'h5api': 'on', 'do': 'wapmenu', 'orderid': 0 })
        cartPage('/app/index.php', queryParams).then(res => {
          const cartindex = res.data
          if (cartindex.wapmenu_type && cartindex.wapmenu_type == 'new_page') {
            window.location.href = cartindex.forward_url
          } else {
            this.sso = cartindex.sso || {}
            this.is_required_address_takeaway = cartindex.store.is_required_address_takeaway == 1 ? true : false
            if (cartindex.cart && cartindex.cart.length) {
              cartindex && todo && todo(cartindex)
              setTimeout(() => {
                this.requested = true
              }, 100)
            } else {
              // console.log('购物车为空，返回首页');
              queryParams["do"] = 'waplist'
              const url = { path: '/', query: queryParams }
              this.$router.push(url)
            }
          }
        }).catch((error) => {
          console.log('====>error', error)
        })
      }
    },
    cleanCoupon() {
      this.coupon_code = ''
      this.cart.summmary.promo.text = 0
    },
    applyCoupon() {
      this.isCoupon = this.coupon_code == 'save10'
      this.cart.summmary.promo.text = 0
      if (this.isCoupon)
        this.cart.summmary.promo.text = -10

      this.popupCoupon = false
    },
    placeorder(isShow) {
      if (isShow) {
        this.loading_confirm = true
        this.show = false
        this.requested = false
        this.submitOrder()
      }
    },
    checkFormField() {
      let tempParams = this.$route.query
      if (tempParams.h5api == undefined) {
        tempParams["h5api"] = 'on'
      }
      tempParams["do"] = 'validateBusinessAndHoliday' 
      const updateOption = () => {
      console.log('tempParams index.vue(Dine In)', tempParams)
      validateBusinessAndHoliday("/app/index.php", tempParams)
            .then(res => {
              console.log('Res data index.vue(Dine-in)', res.data)
              this.indexPage = res.data
              this.store = this.indexPage.store
              console.log('This store data from php , index.vue(Dine-in) ', this.store)

              // 表单检查 
              let isShow = true
              if (this.visiable_realname && !this.receiver_name) {
                this.$toast('The name is required!')
                this.$refs.receiver_name.focus()
                isShow = false
              }
              if (isShow && this.visiable_phone && !this.receiver_phone) {
                this.$toast('The mobile phone number is required!')
                this.$refs.receiver_phone.focus()
                isShow = false
              }
              if (isShow && this.visiable_phone && this.receiver_phone && !this.isMobileValid) {
                this.$toast('Invalid Mobile Number format. Please enter a valid mobile phone.')
                this.$refs.receiver_phone.focus()
                isShow = false
              }
              if (isShow && this.visiable_email && !this.email) {
                this.$toast('The email is required!')
                this.$refs.email.focus()
                isShow = false
              }
              if (this.store.is_rest != 1 || this.store.is_show != 1){
                this.$toast('Merchant is not operating, Please try again later!')
                isShow = false
              }
              if (isShow && !this.checkbox_tc_value) {
                this.$toast('Please agree to FastOrder.my terms & conditions and privacy policy before placing the order.')
                isShow = false
              }
              if (isShow){
              this.placeorder(isShow)
              }
            })
            .catch(error => {
              // console.log('添加到购物车.error', error);
            });
      };
      updateOption();
    },
    submitOrder() {
      const queryParams = this.getUrlParams({ 'h5api': 'on', 'do': 'addtoorder' })
      const postData = {
        type: 'add',
        total: this.cartTotal,
        ordertype: 1,
        address: 'undefined',
        receiver_name: this.receiver_name,
        receiver_phone: this.receiver_phone,
        email: this.email,
        isnew_phone: this.checkbox_mobile_value,
        is_tc: this.checkbox_tc_value,
        sex: 1,
        tables: queryParams.tablesid || 0,
        order_id: 0,
        couponid: 0,
        meal_time: '',
        dispatcharea: '',
        dish_datetime: this.dish_datetime,
        membership_id: this.membership_id,
        receiver_addr1: this.receiver_addr1 || '',
        receiver_addr2: this.receiver_addr2 || '',
        receiver_addr3: this.receiver_addr3 || '',
        counts: 0,
        remark: this.order_remark
      }

      const strApiName = '/app/index.php?' + this.parseParams(queryParams)
      addToOrder(strApiName, postData).then(res => {
        if (res.type == 'ajax' || res.type == 'json') {
          const strUrl = (res.redirect != '' && res.message == '') ? res.redirect : res.data.orderDetailUrl
          window.location.href = strUrl
        } else {
          this.$toast(res.message || 'request network error1')
          this.loading_confirm = false
          this.requestHisOrder = true
          this.requested = true
        }
      }).catch((error) => {
        console.log('网络错误', error);
        this.loading_confirm = false
        this.requested = true
        this.$toast({
          message: 'request network error',
          onClose: () => {
            // queryParams.do = 'waplist'
            // const url = { path: '/', query: queryParams }
            // this.$router.push(url)
          }
        })
      })
    },
    parseParams(data) {
      try {
        var tempArr = [];
        for (var i in data) {
          var key = encodeURIComponent(i);
          var value = encodeURIComponent(data[i]);
          tempArr.push(key + '=' + value);
        }
        var urlParamsStr = tempArr.join('&');
        return urlParamsStr;
      } catch (err) {
        return '';
      }
    },
    evtLogout(option) {
      this.isLogin = option.isLogin
      this.receiver_name = ''
      this.receiver_phone = ''
    },
    funTC(strLink) {
      window.open(strLink, '_blank')
    },
    validateMobileInput({ number, isValid, country }) {
      this.isMobileValid = isValid;
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../../assets/css/common.less');

.cart-index {
  text-align: left;
  margin: 36px 0 40px 0;
  .main {
    background-color: @fff;
    color: #323233;
    .order-store-name {
      padding: 12px 5px 0px 5px;
      font-size: 18px;
      .store-logo {
        margin-right: 10px;
        img {
          width: 40px;
          height: 40px;
          object-fit: fill;
          border-radius: 50%;
        }
      }
    }

    //顶部内容
    .tables-room {
      padding: 5px;
      font-size: @size14;
      .row {
        margin: 5px 0;
        .label {
          flex-basis: 120px;
        }
        .colons {
          font-weight: 700;
          padding: 0 3px;
        }
        .text {
          color: rgba(0, 0, 0, 0.6);
        }
      }
    }
    //菜单列表
    .product-list {
      .item-name {
        flex: 1;
      }
      .item-qty {
        flex-basis: 30px;
        text-align: center;
      }
      .item-price {
        flex-basis: 60px;
        text-align: right;
      }
      .list-header {
        padding: 5px;
      }
      .list-items {
        margin: 5px 0;
        padding: 5px;
        font-size: @size14;
        .item-image {
          flex-basis: 100px;
          margin: 0 8px 0 0;
          img {
            width: 100%;
            max-width: 100px;
            max-height: 75px;
            border-radius: 5px;
          }
        }
      }
      .line-top {
        border-top: 1px solid rgba(0, 0, 0, 0.06);
      }
    }

    .lalmove-dropdown {
      border: 0px;
      background-color: #ffffff;
      font-size: 12px;
      border-radius: 3px;
      border: 1px solid #eeeeee;
      padding: 2px 5px;
      width: 50%;
      .lalmove-dropdown-option {
        height: 20px;
        line-height: 20px;
        font-size: 12px;
      }
    }
    .custom-form {
      margin: 0px 0 106px 0;
      border-top: 1px solid #eee;
    }
    .user-nav-name {
      padding: 4px 12px;

      .user-nav-name-label {
        padding: 0;
        margin: 5px 0 0 0;
        font-size: 14px;
        flex-basis: 105px;
      }
      .user-nav-name-value {
        text-align: right;
        font-size: 12px;
      }
      .select-address {
        margin-left: 10px;
        text-align: right;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.5);
        .delivery-address {
          color: black;
        }
        .delivery-contact {
          color: #ff3838;
        }
      }
      .inputfocus {
        padding: 2px 5px;
        border: 0px;
      }
      .inputfocus:focus {
        box-shadow: 0 0px 5px 0px hsla(191, 84%, 64%, 0.35),
          -10px 10px 10px 10px hsla(0, 0%, 100%, 0.5);
      }
      .contact-phone {
        border: 0px;
        text-align: right;
        font-size: 12px;
        > input.vti__input {
          text-align: right;
        }
      }
    }
    .checkbox-mobile-label {
      padding: 1px 0;
      font-size: 13px;
      .linkcolor {
        color: #0643e9;
      }
    }
    .import_text1 {
      font-weight: bold;
      display: contents;
      font-size: 12px;
    }
    .import_text2 {
      font-weight: bold;
      display: contents;
      font-size: 12px;
    }
  }
  .footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;

    //概览内容
    .summary {
      background-color: #f0f0f0;
      padding: 10px 8px;
      font-size: @size14;
      color: #000000;
      .colons {
        font-weight: 700;
        padding: 0 3px;
      }
      .currency {
        padding: 0 3px;
      }
      .text {
        flex-basis: 50px;
        text-align: right;
        font-size: @size14;
      }
    }

    .place-order {
      background-color: #4d4d4d !important;
      color: #ffffff;
      .rm-price {
        padding-left: 10px;
      }
      .btn-order {
        padding: 10px 8px;
        background-color: #ee0a24 !important;
      }
      .colons {
        border-left: 1px solid rgba(255, 255, 255, 0.8);
        flex-basis: 1px;
        height: 10px;
      }
    }
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #ffffff;
    font-size: 10px;
  }

  .block {
    width: 90%;
    // height: 120px;
    text-align: center;
    background-color: #fff;
    border-radius: 5px;
    padding: 10px;
    font-size: 14px;
    color: #323233;
    .foce-phone-number {
      font-weight: bold;
      font-size: 16px;
      padding: 20px 0;
    }
    .btn-action {
      font-weight: bold;
      font-size: 14px;
      margin: 20px 0 0 0;
      .btn-confirm {
        color: #ee0a24;
      }
      .btn-cancel {
        color: rgba(0, 0, 0, 0.596);
      }
    }
  }
}
</style>